/// <reference path="../../../../node_modules/@ms/office-online-strings/en-US/transcription-strings.d.ts" />
import * as React from 'react';
import { HostAppSettings, HostAppSettingName } from '../../../backend/office-js/HostAppSettings';
import { Dialog, DialogFooter, Icon, Link, Label } from 'office-ui-fabric-react';
import { AppButton } from '../AppButton';
import { LEARN_MORE_URL } from '../../../AppConstants';
import { getDiamondIconStyles, getTopLabelStyles, getModalProps, getDialogContentProps } from './Popup.styles';
import { AppLayoutSettings } from '../../pages/common.styles';

declare const Office:any;

interface LicensePopupState {
    isLicensedUser: boolean
}

export class LicensePopup extends React.PureComponent<{}, LicensePopupState> {
  constructor(props: {}) {
    super(props);

    this.state = {
        isLicensedUser: HostAppSettings.IsSettingTrue(HostAppSettingName.IsLicensedUser),
    };
  }

  private LicenseStateChangedEventListener(args) {
      HostAppSettings.Set(HostAppSettingName.IsLicensedUser, args.isEnabled);
      this.setState({ isLicensedUser: args.isEnabled });
  }

  public componentDidMount() {
    if (!this.state.isLicensedUser) {
        Office.license.onFeatureStateChanged('WordTranscribe', (args) => this.LicenseStateChangedEventListener(args));
        Office.license.onFeatureStateChanged('WordTranscribeConsumer', (args) => this.LicenseStateChangedEventListener(args));
    }
  }

  public render() {
      if (this.state.isLicensedUser) {
          return null;
      } else {
        const title: string | JSX.Element = 
            <div>
                <div>
                    <Icon aria-hidden={true} iconName="Diamond" styles={getDiamondIconStyles()} />
                </div>
                <Label styles={getTopLabelStyles()}>
                    {TranscriptionStrings.LicensePopupTitleLabel}
                </Label>
            </div>
        
        return (
            <Dialog
                dialogContentProps={getDialogContentProps(title)}
                modalProps={getModalProps()}
                hidden={this.state.isLicensedUser}
            >
                <Label styles={AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles()}>{TranscriptionStrings.LicensePopupBodyLabel}</Label>
                <Link styles={AppLayoutSettings.AppCommonStyles.getLearnMoreLinkStyles()} href={LEARN_MORE_URL} target="_blank">{TranscriptionStrings.TranscriptionPaneLearnLabel}</Link>
                <DialogFooter>
                    <AppButton 
                        type={'AppButtonProps'} 
                        id="GoPremiumButton" 
                        text={TranscriptionStrings.LicensePopupGoPremiumLabel}
                        onExecute={async () => { await Office.license.launchUpsellExperience('transcription'); }} 
                    />
                </DialogFooter>
            </Dialog>
         );
      }
  }
}